import type { ReactNode } from 'react';

export const symbol_asterisk: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M458.5-128.63Q450-137.25 450-150v-258L268-226q-8.8 9-20.9 9-12.1 0-21.1-8.84-9-8.84-9-21t9-21.16l182-182H150q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h259L226-693q-9-8.8-9-20.9 0-12.1 8.84-21.1 8.84-9 21-9t21.16 9l182 182v-257q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v258l183-183q8.8-9 20.9-9 12.1 0 21.1 8.84 9 8.84 9 21T735-693L552-510h258q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H553l182 182q9 8.8 9 20.9 0 12.1-8.84 21.1-8.84 9-21 9T693-226L510-409v259q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
